import api from "@/api/axios";

const API_URL = "/ai-feedback";

export const generateBulkFeedback = (sessionId, useRag) =>
  api.post(`${API_URL}/generate`, {
    session_id: sessionId,
    use_rag: useRag
  });

// NEW: Async version that returns immediately with job ID
export const generateBulkFeedbackAsync = (sessionId, useRag) =>
  api.post(`${API_URL}/generate-async`, {
    session_id: sessionId,
    use_rag: useRag
  });

// NEW: Check job status
export const getJobStatus = (jobId) =>
  api.get(`/jobs/${jobId}`);

// NEW: Cancel a running job
export const cancelJob = (jobId) =>
  api.post(`/jobs/${jobId}/cancel`);

export const getPendingFeedback = (sessionId) =>
  api.get(`${API_URL}/pending/${sessionId}`);

export const approveFeedback = (sessionId, feedbackData) =>
  api.post(`${API_URL}/approve/${sessionId}`, feedbackData);

export const clearAllPendingFeedback = (sessionId) =>
  api.delete(`${API_URL}/pending/${sessionId}`);

export const clearIndividualFeedback = (sessionId, userId) =>
  api.delete(`${API_URL}/pending/${sessionId}/${userId}`);

export const getUserSuggestion = (sessionId, userId) =>
  api.get(`${API_URL}/pending/${sessionId}/${userId}`);
